import angular from "angular";
import controller from "./notes.controller";
import template from "./notes.html";

function getStudent($stateParams, UsersModel) {
  return UsersModel.getStudentByID($stateParams.userId).then((response) => {
    return response;
  });
}
getStudent.$inject = ["$stateParams", "UsersModel"];

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.students.view.notes", {
    url: "/notes",
    controller: controller,
    controllerAs: "vm",
    template: template,
    resolve: {
      student: getStudent,
    },
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.students.view.notes", [])
  .config(config)
  .controller("AdminStudentViewNotesController", controller);
